export default {
  thankYou: {
    en: 'Thank you for your order!',
  },
}
